import './PastWebinarIndicator.scss'

import React from 'react'

// https://stackoverflow.com/questions/28589920/create-a-spiders-web-under-a-hr-element-in-css/28602600#28602600
export default function PastWebinarIndicator() {
  return (
    <svg className="past-webinar-indicator" viewBox="0 0 600 250" preserveAspectRatio="none">
      <line x1="1" y1="1" x2="450" y2="250" />
      <line x1="1" y1="1" x2="175" y2="250" />
      <path d="M 1,80 a 12,15 45 1,1 37,-26 a 10,12 0 1,1 14,-24 a 25,20 -45 1,1 40,-30" />
      <path d="M 1,160 a 17,20 45 1,1 75,-52 a 17,20 0 1,1 30,-48 a 30,25 -45 1,1 60,-70" />
      <path d="M 1,240 a 22,25 45 1,1 113,-78 a 23,26 0 1,1 46,-72 a 35,30 -45 1,1 90,-110" />
    </svg>
  )
}
